import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipant } from '../mutations/createParticipant.mutation';
import type { CreateParticipantMutation, CreateParticipantMutationVariables } from '../types';

export const useCreateParticipantMutation = (
  options?: MutationOptions<CreateParticipantMutation, CreateParticipantMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipant), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
